"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function aWebSocketError(status, reason) {
    return aTransportError('websocket', status, reason);
}
exports.aWebSocketError = aWebSocketError;
function anHttpLongPollingError(status, reason) {
    return aTransportError('http_long_polling', status, reason);
}
exports.anHttpLongPollingError = anHttpLongPollingError;
function aTransportError(transport, status, message) {
    return {
        transport: transport,
        status: status,
        message: message,
    };
}
//# sourceMappingURL=transport-error.js.map